// @flow
import React, { type Node } from "react";
import { GridUc, SetupCard } from "@fas/ui-core";
import {
  Box, Grid, Link, Switch, Typography,
} from "@mui/material";
import type { MotivationContent } from "../../containers/MotivationContentList";
import NamedItem from "../NamedItem";
import Collapse from "../Collapse/Collapse";
import type { BrowserLanguage } from "../../containers/CreateMessageGroup";
import CardDivider from "../CardDivider";
import type { Classes } from "../../containers/CampaignView";

type Props = {
  campaignContent: MotivationContent[],
  classes: Classes,
}

const CampViewWebPush = ({ campaignContent, classes }: Props) => (
  <SetupCard title="WebPush Motivation Content">
    {campaignContent.map((motivationContent: MotivationContent, index: number): Node => (
      <Box width="100%" key={motivationContent.id} className={classes.root}>
        <NamedItem name="Id" value={motivationContent.id} />
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">Name</Typography>
          </Grid>
          <Grid item xs={9}>
            <Link
              href={`/webpush/view/${motivationContent.id}`}
              target="_blank"
              underline="hover"
            >
              {motivationContent.name}
            </Link>
          </Grid>
        </GridUc>
        <NamedItem name="WebPush Visualisation Type" value={motivationContent.visualisationType} />
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">isActive</Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch checked={motivationContent.isActive} disabled />
          </Grid>
        </GridUc>
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">Browser Languages</Typography>
          </Grid>
          <Grid item xs={9}>
            <Collapse
              list={motivationContent.BrowserLanguages.map(
                (item: BrowserLanguage): { name: string } => ({ name: item.language })
              )}
              limit={2}
              showMoreDisabled={false}
            />
          </Grid>
        </GridUc>
        <Box mt={3}>
          <CardDivider visible={index < campaignContent.length - 1} />
        </Box>
      </Box>
    ))}
  </SetupCard>
);

export default CampViewWebPush;
